import { ObservationEntity } from '../../../../../coaching-base/config';
import { TranscriptSummaryParams } from '../../../../../coaching-base/general';
import { createAction } from '../../../../../store.model';
import { TranscriptSummaryView } from '../model/transcript-summary-view.model';
import { ActionType } from '../transcript-summary.action';

export interface Reload {
    parameters: TranscriptSummaryParams;
    mode?: 'soft-retain' | 'hard-retain' | null;

    /* this will also expand the parent */
    expandTranscriptIds?: number[];
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING_DETAIL__TS__RELOAD,
);

export interface ReloadResult extends Reload {
    return: TranscriptSummaryView;
    observationConfig?: ObservationEntity;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING_DETAIL__TS__RELOAD_RESULT,
);
